var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 71.92 74.79",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e98d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.13 57.97c0-10.35 3.78-16.79 6.79-21.75 3.88-5.99 5.98-12.95 6.07-20.08.11-8.61-5.16-15.58-5.59-16.14-19.14.85-34.4 17.26-34.4 37.38s15.71 37 35.23 37.41c-2.58-.59-8.1-6.5-8.1-16.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.73 61.94c-.78 0-1.58.05-2.42.1.32 3.83 1.14 7.61 2.42 11.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.73 49.66h-.93c-.8 2.76-1.3 5.6-1.5 8.47 0 .45-.05.89-.05 1.34.82-.06 1.65-.1 2.48-.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.42 9.77c1.65-.53 3.27-1.17 4.84-1.91-4.65-3.42-12.42-6.9-18-7.79 4.02 2.15 10.15 6.27 13.16 9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.73 63.61c-1.77-.44-3.56-.77-5.37-1-1.39 3-3.49 8.33-5.79 11.1 5-2.85 8.36-6.86 11.16-10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.18 74.4c7-.58 14.23-5.32 17.07-8.15-1.57-.74-3.18-1.38-4.83-1.92-3.53 3.97-7.66 7.37-12.24 10.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.15 62.26c1.84.61 3.63 1.35 5.36 2.21 3.09-2.68 5.69-5.87 7.69-9.44-2.44-1.04-4.95-1.89-7.52-2.55-1.39 3.5-3.25 6.79-5.53 9.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.29 61.94-.47 11.37c1.43-1.39 4.13-8.25 4.81-11.11-1.54-.15-2.97-.23-4.34-.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.52 35.82h9.4c-.19-5.02-1.41-9.95-3.58-14.48-2.54 1.09-5.16 1.99-7.83 2.69 1.24 3.81 1.92 7.78 2.01 11.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.51 50.14c2.67.71 5.29 1.61 7.83 2.69 2.17-4.53 3.39-9.45 3.58-14.47h-9.4c-.09 4-.77 7.97-2.01 11.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.67 21.59c2.56-.68 5.07-1.52 7.52-2.53-2.05-3.53-4.65-6.71-7.7-9.43-1.72.87-3.5 1.62-5.33 2.22 2.27 2.98 4.12 6.26 5.51 9.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.29 59.4c1.82.03 3.63.16 5.43.39 1.33-3.14 2.4-6.37 3.21-9.68-2.65-.27-5.55-.43-8.64-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.2 35.82h7.45c-.11-3.11-.48-6.21-1.09-9.26-.87.09-1.78.17-2.7.24-.88 3.14-2.1 6.16-3.66 9.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.07 22.14c-1.4-3.42-3.27-6.63-5.57-9.52-2.02.62-4.08 1.08-6.17 1.39 1.3 3.13 2.36 6.36 3.16 9.65 2.89-.35 5.75-.85 8.58-1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.99 24.62c-2.97.7-5.97 1.23-9 1.59.66 3.16 1.03 6.38 1.12 9.61h9.88c-.1-3.81-.77-7.59-2-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.07 51.9c-2.83-.66-5.69-1.17-8.58-1.51-.81 3.33-1.87 6.59-3.18 9.75 2.08.32 4.15.76 6.18 1.31 2.3-2.91 4.18-6.12 5.58-9.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.29 41.14v6c2.78 0 5.77.19 9.26.5.62-3.05.99-6.15 1.1-9.27h-8.86c-.54.92-1.04 1.84-1.5 2.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.73 10.55c-3-3.16-8.37-8-12.2-9.9 2.41 3.29 5.25 6.06 6.74 11 2.12-.33 3.87-.69 5.46-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.99 38.35h-9.73c-.09 3.23-.47 6.45-1.12 9.61 3.03.37 6.03.9 9 1.58 1.14-3.62 1.77-7.39 1.85-11.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.43 24.24 1.5-.12c-.32-1.32-.67-2.6-1.06-3.85-.05 1.33-.2 2.66-.44 3.97z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLoader);
export default __webpack_public_path__ + "static/media/app_loader.f59e20524eb20f2f74f136312bffcfb7.svg";
export { ForwardRef as ReactComponent };